import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./global.css";
import ScrollToTop from "./components/scroll-to-top/scroll-to-top";

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter>
      <ScrollToTop />
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
);
